import 'phaser'
import { IJob } from '../behavior/jobs'
import { distance } from '../lib/distance-sidecar'
import { l } from '../lib/imports'
import { createId } from '../main/common'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { spriteMap } from './../main/spriteMap-sidecar'
import { IAsteroidData, IAsteroidType } from './asteroidsData'
import { asteroidsData } from './asteroidsData-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { IEntity } from './entitiesUtils'
import { entitiesUtils } from './entitiesUtils-sidecar'

export interface IAsteroid extends IEntity {
  data: IAsteroidData
  image: Phaser.GameObjects.Image
  i: number
  j: number
  supplyLeft: number
  job: IJob | null
}

const objs: IAsteroid[] = []
export function getAll() {
  return objs
}
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}
export function findClosestTo(
  i: number,
  j: number,
  filter: (c: IAsteroid) => boolean,
  invalid: IAsteroid[] = [],
) {
  return distance.findClosestTo(objs, i, j, filter, invalid)
}

export function findAtSpot(
  i: number,
  j: number,
  filter: (c: IAsteroid) => boolean,
): IAsteroid | null {
  let closest: IAsteroid | null = null
  l.forEach(objs, (c) => {
    if (c.i === i && c.j === j) {
      if (filter(c)) {
        closest = c
        return false
      }
    }
  })
  return closest
}

export function create(type: IAsteroidType): IAsteroid {
  let id = createId()
  let data = asteroidsData.dataMapName[type]

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().asteroids,
    data.frame,
    0,
    0,
  )

  let obj: IAsteroid = {
    data,
    eType: 'asteroid',
    id,
    image,
    isDead: false,
    i: -1,
    j: -1,
    supplyLeft: 3,
    job: null,
  }

  objs.push(obj)

  return obj
}

export function moveToTile(
  obj: IAsteroid,
  map: ITileMapShip,
  x: number,
  y: number,
) {
  obj.image.x = map.ox + x * map.tileSize
  obj.image.y = map.oy + y * map.tileSize
  obj.i = x
  obj.j = y
}

export function killAll() {
  objs.forEach((c) => {
    kill(c)
  })
}
export function kill(obj: IAsteroid) {
  let bp = blueprints.findAtSpot(obj.i, obj.j, (c) => c.data.type === 'mine')
  if (bp) {
    blueprints.kill(bp)
  }
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IAsteroid) {
  let ctx = scene.getContext()

  // if (obj.supplyLeft > 0) {
  //   if (obj.allowMine) {
  //     if (obj.job === null || obj.job.isComplete) {
  //       let j = jobs.create('mine')
  //       j.asteroid = obj
  //       obj.job = j
  //     }
  //   }
  // }
}
